
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import * as selectors from './phase0.selectors'
import * as firebaseSelectors from '../../../Core/Firebase/firebase.selectors'

import * as actions from './phase0.actions'
import * as phasesActions from '../phases.actions'

import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'

import ColonyName from './ColonyName'
import ColonyShield from './ColonyShield'
import Federation from './Federation'
import SelectFederation from './SelectFederation'
import Welcome1 from './Welcome1'
import Welcome2 from './Welcome2'
import SettingsConfirmation from './SettingsConfirmation'
import TutorialSelector from './TutorialSelector'

class Phase0Screen extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tabIndex: 0,
      name: '',
      shield: {},
    }
  }

  componentDidMount() {
    const { colonySettings, isTutorialPlayed } = this.props

    let colonyShield = colonySettings.shield || {}
    this.setState({
      tabIndex: isTutorialPlayed ? 1 : 0,
      name: colonySettings.colonyName,
      shield: {
        bannerGeometry: colonyShield.bannerGeometry,
        bannerColor: colonyShield.bannerColor,
        emblemGeometry: colonyShield.emblemGeometry,
      },
    })
  }

  saveName(name) {
    const { saveColonyName, addHowlSound } = this.props
    saveColonyName({ name })

    this.setState({ name })
    this.displayTab(4) // todo move this logic to redux - sagas to avoid side effects
    addHowlSound('button_click_icon')
  }

  saveShield(federationsType) {
    const { saveColonyShield, addHowlSound } = this.props
    const selectFederationManually = federationsType === 'manual'
    const federationSelectedAutomatically = federationsType === 'automatic'
    const goToPhase = !selectFederationManually && !federationSelectedAutomatically

    saveColonyShield({ shield: this.state.shield, goToPhase })
    if (selectFederationManually) {
      this.displayTab(6)
    } else if (federationSelectedAutomatically) {
      this.displayTab(7)
    }
    addHowlSound('button_click_icon')
  }

  configureShield(shield) {
    this.setState({
      shield: shield,
    })
    this.displayTab(5)
  }

  displayTab(tabIndex) {
    const { addHowlSound } = this.props
    addHowlSound('button_click_icon')
    this.setState({
      tabIndex: tabIndex,
    })
  }

  render() {
    const { goToPhase, groupConfig, colonySettings } = this.props

    return (
      <Tabs
        selectedIndex={this.state.tabIndex}
        onSelect={(tabIndex) => this.setState({ tabIndex })}
      >
        <TabList>
          <Tab></Tab>
          <Tab></Tab>
          <Tab></Tab>
          <Tab></Tab>
          <Tab></Tab>
          <Tab></Tab>
          <Tab></Tab>
          <Tab></Tab>
        </TabList>
        <TabPanel>
          <TutorialSelector next={() => this.displayTab(1)} />
        </TabPanel>
        <TabPanel>
          <Welcome2 next={() => this.displayTab(2)} />
        </TabPanel>
        <TabPanel>
          <Welcome1 next={() => this.displayTab(3)} />
        </TabPanel>
        <TabPanel>
          <ColonyName
            name={this.state.name}
            next={(name) => this.saveName(name)}
            error={this.props.error}
          />
        </TabPanel>
        <TabPanel>
          <ColonyShield
            name={this.state.name}
            shield={this.state.shield}
            next={(shield) => this.configureShield(shield)}
          />
        </TabPanel>
        <TabPanel>
          <SettingsConfirmation
            name={this.state.name}
            shield={this.state.shield}
            next={() => this.saveShield(groupConfig.federationsType)}
            cancel={() => this.displayTab(3)}
          />
        </TabPanel>
        <TabPanel>
          <SelectFederation
            name={this.state.name}
            shield={this.state.shield}
            next={() => this.displayTab(7)}
          />
        </TabPanel>
        <TabPanel>
          <Federation name={this.state.name} shield={this.state.shield} next={() => goToPhase(1)} />
        </TabPanel>
      </Tabs>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    groupConfig: firebaseSelectors.getGroupData(state),
    colonySettings: firebaseSelectors.getUserDataShield(state),
    isTutorialPlayed: selectors.isTutorialPlayed(state),
    error: selectors.getError(state),
    name: selectors.getName(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveColonyName: bindActionCreators(actions.saveColonyName, dispatch),
    saveColonyShield: bindActionCreators(actions.saveColonyShield, dispatch),
    saveSelectedFederation: bindActionCreators(actions.saveSelectedFederation, dispatch),
    goToPhase: bindActionCreators(phasesActions.goToPhase, dispatch),
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  }
}

Phase0Screen.propTypes = {
  groupConfig: PropTypes.object,
  colonySettings: PropTypes.object,
  error: PropTypes.any,
  saveColonyName: PropTypes.func,
  saveColonyShield: PropTypes.func,
  saveSelectedFederation: PropTypes.func,
  addHowlSound: PropTypes.func,
  goToPhase: PropTypes.func,
  isTutorialPlayed: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Phase0Screen))
